import { render, staticRenderFns } from "./Storno.vue?vue&type=template&id=3ecbc49c&"
import script from "./Storno.vue?vue&type=script&lang=js&"
export * from "./Storno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports